import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrincipalLayoutComponent } from '../../layout/principal-layout/principal-layout.component';
import { CategoriasComponent } from './categorias.component';

const routes: Routes = [
  {
    path: 'categorias',
    component: PrincipalLayoutComponent,
    children: [
      { path: '', component: CategoriasComponent },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CategoriasRoutingModule { }
